// import React, { useState, useEffect } from "react";

// const USER_TYPES = [
//   "Global",
//   "admin",
//   "agent",
//   "owner",
//   "investor",
//   "projectHead",
// ];

// export default function NotificationPage() {
//   const [notifications, setNotifications] = useState([]);
//   const [formData, setFormData] = useState({
//     userType: "Global",
//     title: "",
//     description: "",
//     image: null,
//   });

//   // 🔹 Handle input
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // 🔹 Handle file
//   const handleFileChange = (e) => {
//     setFormData({ ...formData, image: e.target.files[0] });
//   };

//   // 🔹 Submit notification
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const data = new FormData();
//     data.append("userType", formData.userType);
//     data.append("title", formData.title);
//     data.append("description", formData.description);
//     data.append("image", formData.image);

//     // 🔗 API CALL (replace URL)
//     /*
//     await fetch("/api/notifications", {
//       method: "POST",
//       body: data,
//     });
//     */

//     // Temporary frontend-only demo
//     setNotifications([
//       ...notifications,
//       {
//         id: Date.now(),
//         ...formData,
//         imagePreview: formData.image
//           ? URL.createObjectURL(formData.image)
//           : null,
//       },
//     ]);

//     setFormData({
//       userType: "Global",
//       title: "",
//       description: "",
//       image: null,
//     });
//   };

//   // 🔹 Delete
//   const handleDelete = (id) => {
//     setNotifications(notifications.filter((n) => n.id !== id));
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-4 md:p-8">
//       <div className="max-w-7xl mx-auto">
//         <h1 className="text-2xl font-bold mb-6">📢 Notification Management</h1>

//         {/* CREATE FORM */}
//         <form
//           onSubmit={handleSubmit}
//           className="bg-white rounded-xl shadow p-6 mb-8 grid grid-cols-1 md:grid-cols-2 gap-4"
//         >
//           <div>
//             <label className="block text-sm font-medium mb-1">
//               User Type
//             </label>
//             <select
//               name="userType"
//               value={formData.userType}
//               onChange={handleChange}
//               className="w-full border rounded-lg px-3 py-2"
//             >
//               {USER_TYPES.map((type) => (
//                 <option key={type} value={type}>
//                   {type === "Global"
//                     ? "Global (All Users)"
//                     : type}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div>
//             <label className="block text-sm font-medium mb-1">
//               Title
//             </label>
//             <input
//               type="text"
//               name="title"
//               required
//               value={formData.title}
//               onChange={handleChange}
//               className="w-full border rounded-lg px-3 py-2"
//               placeholder="Enter title"
//             />
//           </div>

//           <div className="md:col-span-2">
//             <label className="block text-sm font-medium mb-1">
//               Description
//             </label>
//             <textarea
//               name="description"
//               rows="3"
//               value={formData.description}
//               onChange={handleChange}
//               className="w-full border rounded-lg px-3 py-2"
//               placeholder="Enter description"
//             />
//           </div>

//           <div className="md:col-span-2">
//             <label className="block text-sm font-medium mb-1">
//               Image
//             </label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFileChange}
//               className="w-full"
//             />
//           </div>

//           <div className="md:col-span-2 flex justify-end">
//             <button
//               type="submit"
//               className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
//             >
//               ➕ Create Notification
//             </button>
//           </div>
//         </form>

//         {/* TABLE */}
//         <div className="bg-white rounded-xl shadow overflow-x-auto">
//           <table className="min-w-full text-sm">
//             <thead className="bg-gray-200">
//               <tr>
//                 <th className="p-3 text-left">User Type</th>
//                 <th className="p-3 text-left">Title</th>
//                 <th className="p-3 text-left">Description</th>
//                 <th className="p-3 text-left">Image</th>
//                 <th className="p-3 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {notifications.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan="5"
//                     className="p-4 text-center text-gray-500"
//                   >
//                     No notifications yet
//                   </td>
//                 </tr>
//               )}

//               {notifications.map((n) => (
//                 <tr
//                   key={n.id}
//                   className="border-t hover:bg-gray-50"
//                 >
//                   <td className="p-3">{n.userType}</td>
//                   <td className="p-3 font-medium">{n.title}</td>
//                   <td className="p-3">{n.description}</td>
//                   <td className="p-3">
//                     {n.imagePreview && (
//                       <img
//                         src={n.imagePreview}
//                         alt="preview"
//                         className="h-12 w-12 object-cover rounded"
//                       />
//                     )}
//                   </td>
//                   <td className="p-3 text-center">
//                     <button
//                       onClick={() => handleDelete(n.id)}
//                       className="text-red-600 hover:underline"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import axios from "axios";
import "./notification.css";

function NotificationPage() {
    const [form, setForm] = useState({
        userType: "",
        title: "",
        description: "",
        // image: null
         profile_photo: null
    });
    const [data, setData] = useState([]);

    const fetchData = async () => {
        const res = await axios.get("https://api.propertygalleria.in/master/api/api/notifications");
        setData(res.data);
    };

    useEffect(() => {
        fetchData(data);
    }, []);

    const handleChange = (e) => {
        if (e.target.name === "image") {
            setForm({ ...form, image: e.target.files[0] });
        } else {
            setForm({ ...form, [e.target.name]: e.target.value });
        }
    };

    const handleSubmit1 = async (e) => {
        e.preventDefault();
        const fd = new FormData();
        Object.keys(form).forEach(key => fd.append(key, form[key]));

        await axios.post("https://api.propertygalleria.in/master/api/api/notifications", fd);
        fetchData();
    };

    const deleteNotification = async (id) => {
        await axios.delete(`https://api.propertygalleria.in/master/api/api/notifications/${id}`);
        fetchData();
    };



    const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append("userType", form.userType);
  formData.append("title", form.title);
  formData.append("description", form.description);
  formData.append("profile_photo", form.profile_photo); // 👈 MUST MATCH BACKEND

  await axios.post(
    "https://api.propertygalleria.in/master/api/api/notifications",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );

  alert("Notification Created");
};

    return (
        <div className="container">
            <h1>📢 Notification Manager</h1>

            <form className="card" onSubmit={handleSubmit}>
                <select name="userType" onChange={handleChange} required>
                    <option value="">Select User Type</option>
                    <option value="global">Global for All</option>
                    <option value="admin">Admin</option>
                    <option value="agent">Agent</option>
                    <option value="owner">Owner</option>
                    <option value="investor">Investor</option>
                    <option value="projectHead">Project Head</option>
                </select>

                <input type="text" name="title" placeholder="Title" onChange={handleChange} required />
                <textarea name="description" placeholder="Description" onChange={handleChange} required />
                {/* <input type="file" name="profile_photo" onChange={handleChange} /> */}

                <input
                    type="file"
                    name="profile_photo"
                    onChange={(e) =>
                        setForm({ ...form, profile_photo: e.target.files[0] })
                    }
                />

                <button>Submit Notification</button>
            </form>

            <div className="table">
                {data.map(n => (
                    <div className="row" key={n.id}>
                        <div>
                            <h4>{n.title}</h4>
                            <p>{n.description}</p>
                            <span>{n.userType}</span>
                        </div>
                        {n.image && (
                            <img src={`${n.image}`} alt="" />
                        )}
                        <button onClick={() => deleteNotification(n.id)}>❌</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default NotificationPage;
